module.exports = __webpack_public_path__ + "static/media/public-match.2fb8c4f9.svg";